<template>
  <BLayoutList
    :title="pageTitle"
    :skeleton="isLoadingAsyncData"
  >
    <template #filter>
      <ComponentFilter
        :data="filters"
        :skeleton="isLoadingAsyncData"
        @change="onChangeFilter"
      />
    </template>

    <BTableCommon
      v-model="selected"
      type="sessions"
      :list="list"
      :pagination="pagination"
      :ordering="filters.ordering"
      :loading="isLoading"
      :skeleton="isLoadingAsyncData"
      @change:pagination="onChangePagination"
      @change:sort="onChangeSort"
      @action:logout="onLogout"
    />
  </BLayoutList>
</template>

<script>
import { createListMixin } from '@/helpers/mixins/createListMixin'
import { SessionModel as Model } from './Model'
import {
  sessionsStoreModule as StoreModule,
  sessionsMapper as StoreMapper,
} from './store'

import BLayoutList from '@/components/layouts/BLayoutList.vue'
import BTableCommon from '@/components/tables/BTableCommon.vue'
import ComponentFilter from './components/SessionsFilter.vue'


const mixinOptions = { Model, StoreModule }
const listMixin = createListMixin(mixinOptions)

/** @typedef { import('@/helpers/mixins/createListMixin').ListMixin<{}, StoreModule> } List */

export default {
  name: 'ViewSessionsAll',
  components: {
    BLayoutList,
    BTableCommon,
    ComponentFilter,
  },
  mixins: [
    listMixin,
  ],
  methods: {
    ...StoreMapper.mapActions(['logoutSession']),

    async onLogout(payload, callback) {
      const watched = callback?.()

      try {
        await this.logoutSession({ payload })
        await this.onGetData(this.filters)
      } catch (e) {
        const message = Model.response_error.logout(payload)
        this.$notice.errors(e, { message })
      }

      if (watched) watched()
    },
  },
}
</script>
